import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useUiStore = defineStore('ui', () => {
  // State
  const isLoading = ref<boolean>(false);

  // Actions
  function showLoader() {
    isLoading.value = true;
  }

  function hideLoader() {
    isLoading.value = false;
  }

  // Simulate showing loader for a duration (like your original setTimeout)
  function showLoaderForDuration(duration: number = 300) {
    showLoader();
    setTimeout(() => {
      hideLoader();
    }, duration);
  }

  return { isLoading, showLoader, hideLoader, showLoaderForDuration };
});